import '../../App.css';
import React, { useContext, useEffect, useRef } from "react";
import { ApiContext } from "../../context/ApiContext";
import { Form, Row, Col } from 'react-bootstrap';
import { FaTimes, FaPlus, FaImage, } from 'react-icons/fa';
import { FiDownload } from 'react-icons/fi';
import { TbTrash } from 'react-icons/tb';
import { StyleContext } from '../../context/StyleContext';
import { ServicoContext } from '../../context/ServicoContext';

function ModalEditarPratica({ currentPage }) {
    const { EditarPratica, EdicaoPratica, setEdicaoPratica, setModalEditarPratica, setError, AdicionarAnexo, setAddFile, ExcluirAnexo, ListaAnexo, File, BaixarAnexo } = useContext(ServicoContext)
    const { Permissao } = useContext(ApiContext)
    const { btnVer, btnCriar, btnPesquisar } = useContext(StyleContext)
    const anexoRef = useRef()

    const editar = (e) => {
        if (e) e.preventDefault();
        if (!EdicaoPratica.nome) {
            setError("Nome não informado");
            setTimeout(() => {
                setError("");
            }, 3000);
            return;
        }
        EditarPratica(currentPage)
            .then(() => {
                setModalEditarPratica(false)
            })
            .catch((error) => {
                console.log(error)
            })
    }

    const adicionarAnexo = (event) => {
        const file = event.target.files[0];
        if (!file) return;

        setAddFile(file);
    };

    const addAnexo = () => {
        AdicionarAnexo()
            .then(() => {
                setAddFile(null)
                anexoRef.current.value = ""
            })
    }

    const handleChange = (event) => {
        setEdicaoPratica({ ...EdicaoPratica, [event.target.name]: event.target.value })
    }

    useEffect(() => {
        ListaAnexo()
    }, [])

    return (
        <div className="modal-novo">
            <div className="modal-novo-interno">
                <div className="header-modal">
                    <h1 className="h1-modal">Editar prática de referência</h1>
                    <div className="btn-close-modal" onClick={() => setModalEditarPratica(false)}>
                        <FaTimes />
                    </div>
                </div>
                <div>
                    <div className="modal-content">
                        <Row>
                            <Col>
                                <Form.Group className="mb-3">
                                    <Form.Label>Nome</Form.Label>
                                    <Form.Control maxLength={255} defaultValue={EdicaoPratica.nome} onChange={handleChange} name="nome" />
                                </Form.Group>
                            </Col>
                        </Row>
                        <Row>
                            <Col>
                                <Form.Group className="mb-3">
                                    <Form.Label>Descrição</Form.Label>
                                    <Form.Control maxLength={255} defaultValue={EdicaoPratica.descricao} onChange={handleChange} name="descricao" />
                                </Form.Group>
                            </Col>
                        </Row>
                        <div>
                            <Form.Group className="mb-3">
                                <Form.Label>Anexo</Form.Label>
                                <Form.Control type='file' onChange={adicionarAnexo} name="file" accept=".pdf,.doc,.docx,.png,.jpg,.jpeg,.txt" ref={anexoRef} />
                            </Form.Group>
                            <div style={{ display: "flex", justifyContent: "flex-end" }} className="mb-3">
                                <button type="button" className="btn-dash btn-pesquisar" style={btnPesquisar} onClick={() => addAnexo()}><FaPlus style={{ marginRight: "5px" }} />Adicionar anexo</button>
                            </div>
                            <div style={{ display: 'flex', gap: '35px', flexWrap: 'wrap', maxHeight: '300px', overflow: 'auto' }}>
                                {File && File?.map((item, index) => {
                                    return (
                                        <div key={index} style={{ display: 'flex', flexDirection: 'column', alignItems: 'center', width: '200px', marginBottom: '10px' }}>
                                            <div style={{ display: 'flex', flexDirection: 'column', alignItems: 'center' }}>
                                                <FaImage style={{ fontSize: '40px' }} />
                                                <span style={{ wordBreak: 'break-word' }}>{item.nomeArquivo}</span>
                                            </div>
                                            <div className="div-button">
                                                <button type="button" className="btn-download" onClick={() => BaixarAnexo(item.key)}><FiDownload /></button>
                                                <button type="button" className="btn-del" onClick={() => ExcluirAnexo(item.key)}><TbTrash /></button>
                                            </div>
                                        </div>
                                    )
                                })}
                            </div>
                        </div>
                    </div>
                    <div className="footer-modal-criar-demanda">
                        <button type="button" className="btn-dash btn-ver" style={btnVer} onClick={() => setModalEditarPratica(false)}>Cancelar</button>
                        {(!!Permissao.find(item => item.menu.descricao === "CADASTROS" && item.edicao === true)) &&
                            <button type='button' className="btn-dash btn-criar" style={btnCriar} onClick={(e) => {
                                e.preventDefault();
                                editar();
                            }}>Salvar</button>
                        }
                    </div>
                </div>
            </div>
        </div>
    )
}

export default ModalEditarPratica